import React from 'react';

export interface FacebookProps {
  className?: string;
}

const Facebook: React.FC<FacebookProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 9 15" fill="none" className={className}>
      <path
        d="M7.54178 8.84377L7.93267 6.29747H5.48926V4.64508C5.48926 3.9486 5.83047 3.26926 6.92488 3.26926H8.03556V1.10155C8.03556 1.10155 7.02777 0.929626 6.06395 0.929626C4.05189 0.929626 2.73675 2.14935 2.73675 4.35708V6.29791H0.5V8.84421H2.73675V15H5.48926V8.84421L7.54178 8.84377Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Facebook;
